var _require = require('iso-url'),
    relative = _require.relative;

var map = {
  http: 'ws',
  https: 'wss'
};
var def = 'ws';

module.exports = function (url, location) {
  return relative(url, location, map, def);
};